import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { Doughnut } from 'react-chartjs-2';
//tabs related import
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import Badge from '@material-ui/core/Badge';
import { Divider, Hidden } from '@material-ui/core';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import ribbon from '../../pic/ribbon.PNG';
import data_card from '../../pic/data.PNG';
import duty_card from '../../pic/duty.PNG';
import vendor_card from '../../pic/vendor.PNG';
import transaction_card from '../../pic/transaction.PNG';
import timing_card from '../../pic/timing.PNG';
import record_card from '../../pic/record.PNG';
import SearchIcon from '@material-ui/icons/Search';
import config from "../../config/config";
import axios from 'axios';
import TextField from '@material-ui/core/TextField';
import { money_convert } from '../../util/StringUtil';
import statusOpen from '../../pic/open.PNG';

import CustomizedTable from "../CSSComponent/table"

import statusReview from '../../pic/review.PNG';
import clsx from 'clsx';
import { lighten } from '@material-ui/core/styles';
import TablePagination from '@material-ui/core/TablePagination';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import DeleteIcon from '@material-ui/icons/Delete';
import FilterListIcon from '@material-ui/icons/FilterList';
import { grid_spacing, styles } from '../CSS/Styles';

const StyledTableCell = withStyles({
    // head: {
    //     backgroundColor: "#e0e0e0",
    //     color: "#757575",
    //   },
    body: {
        fontSize: 14,
    },
    root: {
             paddingRight: 2,
             paddingLeft: 2,
             //display: 'flex',
             //flexDirection: 'row'
        //     borderBlockEnd:{
        // display: false,
        //     },
    },
})(TableCell);

const StyledTableRow = withStyles({
    head: {
        backgroundColor: "#e0e0e0",
        color: "#757575",
    },
    root: {
        // height: '36px',
        //display: 'flex',
        //flexDirection: 'row'
    },
})(TableRow);



function getRandomInt(min, max) {
    return Math.random() > 0.2 ? 0 : (Math.floor(Math.random() * (max - min + 1)) + min) * 100000;
}

const getState = () => ({
    data_tender_trending: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Purchase Order',
                backgroundColor: 'rgba(234,170,0,0.8)',
                borderColor: 'rgba(246,141,46,1)',
                //pointColor: 'rgba(220,220,220,1)',
                //pointStrokeColor: '#fff',
                //pointHighlightFill: '#fff',
                //pointHighlightStroke: 'rgba(220,220,220,1)',
                data: [1000000.00 + getRandomInt(-5, 10),
                1300000.00 + getRandomInt(-5, 10),
                985968.00 + getRandomInt(-5, 10),
                700000.00 + getRandomInt(-5, 10),
                3400000.00 + getRandomInt(-5, 10),
                6200000.00 + getRandomInt(-5, 10),
                4800000.00 + getRandomInt(-5, 10),
                980000.00 + getRandomInt(-5, 10),
                1300000.00 + getRandomInt(-5, 10),
                960000.00 + getRandomInt(-5, 10),
                500000.00 + getRandomInt(-5, 10),
                1700000.00 + getRandomInt(-5, 10)],
            },
        ]
    },

    data_invoice_trending: {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Invoice',
                backgroundColor: 'rgba(0,145,218,0.5)',
                borderColor: 'rgba(0,94,184,1)',
                //pointColor: 'rgba(220,220,220,1)',
                //pointStrokeColor: '#fff',
                //pointHighlightFill: '#fff',
                //pointHighlightStroke: 'rgba(220,220,220,1)',
                data: [17000000.00 + getRandomInt(-5, 100),
                11000000.00 + getRandomInt(-5, 100),
                17000000.00 + getRandomInt(-5, 100),
                12000000.00 + getRandomInt(-5, 100),
                37000000.00 + getRandomInt(-5, 100),
                20000000.00 + getRandomInt(-5, 100),
                10000000.00 + getRandomInt(-5, 100),
                13000000.00 + getRandomInt(-5, 100),
                11000000.00 + getRandomInt(-5, 100),
                6600000.00 + getRandomInt(-5, 100),
                16000000.00 + getRandomInt(-5, 100),
                14000000.00 + getRandomInt(-5, 100)],
            },
        ]
    }
});

class MyDashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: 0
        }
    }

    handleChange = (event, value) => {
        this.setState({ value });
    };




    getTasks() {
        axios.get(config.task)
            .then(res => {
                let tasks = res.data;
                let task_data = []
                task_data.push(tasks.filter(task => task.status == 'Draft').length)
                task_data.push(tasks.filter(task => task.status == 'Pending Response').length)
                task_data.push(tasks.filter(task => task.status == 'Pending Review').length)
                task_data.push(tasks.filter(task => task.status == 'Rejected').length)
                task_data.push(tasks.filter(task => task.status == 'Completed').length)
                // console.log("in dashboard")
                // console.log(res)
                // console.log(alert_data)
                let data = {
                    labels: [
                        'Draft',
                        'Pending Response',
                        'Pending Review',
                        'Rejected',
                        'Completed'
                    ],
                    datasets: [{
                        data: task_data,
                        backgroundColor: [
                            '#FF6384',
                            '#36A2EB',
                            '#FFCE56',
                            '#990099',
                            '#ff9900'
                        ],
                        hoverBackgroundColor: [
                            '#FF6384',
                            '#36A2EB',
                            '#FFCE56',
                            '#FF6384',
                            '#36A2EB'
                        ]
                    }]
                }
                this.setState({
                    taskStatusData: data
                })
            })
    }
    getAlerts() {
        axios.get(config.allAlerts)
            .then(res => {
                let alerts = res.data;
                let alert_data = []
                alert_data.push(alerts.filter(alert => alert.status == 'Open').length)
                alert_data.push(alerts.filter(alert => alert.status == 'Investigating').length)
                alert_data.push(alerts.filter(alert => alert.status == 'Pending Review').length)
                alert_data.push(alerts.filter(alert => alert.status == 'Pending Approval For Closure').length)
                alert_data.push(alerts.filter(alert => alert.status == 'Closed').length)
                // console.log("in dashboard")
                // console.log(res)
                // console.log(alert_data)
                let data = {
                    labels: [
                        'Open',
                        'Investigating',
                        'Pending Review',
                        'Pending Approval For Closure',
                        'Closed'
                    ],
                    datasets: [{
                        data: alert_data,
                        backgroundColor: [
                            '#FF6384',
                            '#36A2EB',
                            '#FFCE56',
                            '#990099',
                            '#ff9900'
                        ],
                        hoverBackgroundColor: [
                            '#FF6384',
                            '#36A2EB',
                            '#FFCE56',
                            '#FF6384',
                            '#36A2EB'
                        ]
                    }]
                }
                this.setState({
                    alertStatusData: data
                })
            })
    }
    getInitialState() {
    }

    componentDidMount() {
    }

    componentWillMount() {

    }
    render() {
        const { classes } = this.props;

        const recentlyViewedAlertsData = {
            headers: ["Alert Group",
                "Alert Name",
                "Details",
                "Created Date",
                "Last Modified Date",
                "Risk",
                "Status",],
            items: [
                {
                    group: 'Data Quality',
                    name: 'Missing Vendor ID',
                    details: 'PO missing vendor ID',
                    created_date: '12/06/18',
                    last_modified_date: '24/08/18',
                    risk: 'Low',
                    status: <img src={statusOpen}/>,
                },
            ],
        };

        const recentlyViewedAlertsDataTableHeaderMap={
            "Alert Group": "group",
            "Alert Name": "name",
            "Details": "details",
            "Created Date": "created_date",
            "Last Modified Date": "last_modified_date",
            "Risk": "risk",
            "Status": "status"
        }

        const allMyAlertsData = {
            headers: ["No.",
                "Alert Group",
                "Alert Name",
                "Details",
                "Created Date",
                "Last Modified Date",
                "Risk",
                "Status",],
            items: [
                {
                    id: 1,
                    group: 'Data Quality',
                    name: 'Missing Vendor ID',
                    details: 'PO missing vendor ID',
                    created_date: '12/06/18',
                    last_modified_date: '24/08/18',
                    risk: 'Low',
                    status: <img src={statusOpen} />,
                },
                {
                    id: 2,
                    group: 'Unusual Vendor Records',
                    name: 'Staff relationship with Vendor',
                    details: 'Abigail Morton Pte Ltd',
                    created_date: '23/07/18',
                    last_modified_date: '5/08/18',
                    risk: 'Medium',
                    status:<img src={statusReview} />,
                },
                {
                    id: 3,
                    group: 'Data Quality',
                    name: 'Duplicate Details',
                    // details: ['Abigail Morton Pte Ltd', 'Alexander Bryne LLP', 'Alexander Jones LLP'],
                    details: ['Alexander Jones LLP'],
                    created_date: '24/07/18',
                    last_modified_date: '3/08/18',
                    risk: 'High',
                    status: <img src={statusReview} />,
                },
            ],
        };

        const allMyAlertsDataTableHeaderMap = {
            "No.": "id",
            "Alert Group": "group",
            "Alert Name": "name",
            "Details": "details",
            "Created Date": "created_date",
            "Last Modified Date": "last_modified_date",
            "Risk": "risk",
            "Status": "status",
        }

        const searchBar = (<div className={classes.margin}>
            <Grid container spacing={grid_spacing} alignItems="flex-end">
                <Grid item>
                    <SearchIcon />
                </Grid>
                <Grid item>
                    <TextField id="input-with-icon-grid" label="Search..." fullWidth={true} value={this.state.inputValue} />
                </Grid>
            </Grid>
            <Divider />
        </div>);

        const doughnut_data = {
            labels: [
                'Open',
                'Under review'
            ],
            datasets: [{
                data: [40, 25],
                backgroundColor: [
                    '#4383cc',
                    '#4a126b'
                ],
                hoverBackgroundColor: [
                    '#4383cc',
                    '#4a126b'
                ]
            }],
            //text: '23%'
        };

        const alert_by_time_data = {
            labels: ['22 Jun 2019', '23 Jun 2019', '24 Jun 2019', '25 Jun 2019', '26 Jun 2019', '27 Jun 2019', '28 Jun 2019', '29 Jun 2019', '30 Jun 2019', '01 Jul 2019', '02 Jul 2019', '03 Jul 2019'],
            datasets: [
                {
                    // label: '',
                    fill: false,
                    // lineTension: 0.1,
                    // backgroundColor: 'rgba(0,0,0,0)',
                    borderColor: 'rgb(0,145,218)',
                    // borderCapStyle: 'butt',
                    // // borderDash: [],
                    // borderDashOffset: 0.0,
                    // borderJoinStyle: 'miter',
                    pointBorderColor: 'rgb(0,145,218)',
                    pointBackgroundColor: 'rgb(0,145,218)',
                    //pointBorderWidth: 1,
                    // pointHoverRadius: 5,
                    pointHoverBackgroundColor: 'rgb(0,145,218)',
                    pointHoverBorderColor: 'rgb(0,145,218)',
                    // pointHoverBorderWidth: 2,
                    // pointRadius: 1,
                    // pointHitRadius: 10,
                    data: [12, 14, 13, 14, 15, 12, 11, 14, 14, 15, 13, 12]
                }
            ]
        };


        const ageing_of_alerts_data = {
            labels: ['0-30 days', '31-60 days', '61-90 days', '90+ days'],
            datasets: [
                {
                    label: '',
                    backgroundColor: ['#ffab91', '#ff8a65', '#d84315', '#bf360c'],
                    //borderColor: 'rgba(255,99,132,1)',
                    //borderWidth: 1,
                    //hoverBackgroundColor: 'rgba(255,99,132,0.4)',
                    //hoverBorderColor: 'rgba(255,99,132,1)',
                    data: [29, 11, 4, 15]
                }
            ]
        };


        const alerts_resolved_data = {
            labels: ["27/6/2019", "28/6/2019", "29/6/2019", "30/6/2019", "1/7/2019", "2/7/2019", "3/7/2019"],
            datasets: [{
                label: 'Team member A',
                data: [5, 3, 4, 5, 6, 4, 7],
                fill: false,
                borderColor: "rgb(0,145,218)",
                borderDash: [5, 5],
                backgroundColor: "rgb(0,145,218)",
                // pointBorderColor: '#EC932F',
                // pointBackgroundColor: '#EC932F',
                // pointHoverBackgroundColor: '#EC932F',
                // pointHoverBorderColor: '#EC932F',
                pointStyle: "dash",
            }, {
                label: 'Team member B',
                data: [10, 4, 7, 8, 19, 19, 9],
                fill: false,
                borderColor: '#EC932F',
                borderDash: [5, 5],
                backgroundColor: '#EC932F',
                // pointBorderColor: '#EC932F',
                // pointBackgroundColor: '#EC932F',
                // pointHoverBackgroundColor: '#EC932F',
                // pointHoverBorderColor: '#EC932F',
                pointStyle: "dash",
            }, {
                label: 'Total',
                data: [15, 7, 11, 13, 25, 23, 16],
                fill: false,
                borderColor: '#757575',
                //,borderDash: [5, 5],
                backgroundColor: '#757575',
                // pointBorderColor: '#EC932F',
                // pointBackgroundColor: '#EC932F',
                // pointHoverBackgroundColor: '#EC932F',
                // pointHoverBorderColor: '#EC932F',
                pointStyle: "line",
            }]
        };


        return (
            <div flexGrow={1} >
                <Grid container style={{ marginTop: "1%", height: "36vh" }} spacing={grid_spacing}>
                    <Grid item xs={4} style={{ height: "100%" }}>
                        <Card style={{ height: "100%" }}>
                            <div className={classes.details}>
                                <div className={classes.cardHeader}>
                                    <Typography variant="h6">
                                        My Alerts
                                </Typography>
                                </div>
                                <CardContent className={classes.content} >
                                    <Doughnut
                                        data={doughnut_data}
                                        options={{
                                            plugins: {
                                                datalabels: {
                                                    display: false
                                                }
                                            },
                                            legend: {
                                                display: false,
                                            },
                                            cutoutPercentage: 70,
                                            responsive: true,
                                            maintainAspectRatio: true,
                                        }}
                                        height={'120%'}
                                    />
                                    {console.log("1 time")}
                                </CardContent>
                            </div>
                        </Card>
                    </Grid>
                    {/* <Grid item xs={8}>   */}
                    <Grid item xs={8}>
                        <Card style={{ height: "100%" }} >
                            <CustomizedTable
                                titleText= {"Recently Viewed Alerts"}
                                tableHeader={recentlyViewedAlertsData.headers}
                                data={recentlyViewedAlertsData.items}
                                tableHeaderMap={recentlyViewedAlertsDataTableHeaderMap}
                                tableStyle={'compact'}
                            />
                        </Card>
                    </Grid>
                    <Grid spacing={grid_spacing} style={{ display: 'flex', marginTop: "1%", width: "100%", justifyContent: "center", height: "50vh"}}>
                        <Card style={{ minHeight: 200, height: "100%", width: "100%" }}>
                            <CustomizedTable
                                titleText= {"All My Alerts"}
                                tableHeader={allMyAlertsData.headers}
                                data={allMyAlertsData.items}
                                tableHeaderMap={allMyAlertsDataTableHeaderMap}
                                tableStyle={'compact'}
                                searchBar = {true}
                            />
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(MyDashboard);


// WEBPACK FOOTER //
// ./src/components/Dashboard/MyDashboard_demo.js